import SegmentedFilter from "@/components/SegmentedFilter";
import { TYPE_LABELS, TYPE_ORDER } from "@/lib/complaintTypes";

/**
 * Barre de typologies de la page Litiges.
 *
 * Les six typologies sont affichées en permanence, avec leur compteur, y
 * compris à zéro.
 */
export default function TypeBar({ value, onChange, counts = {}, total = 0, types = TYPE_ORDER }) {
  const options = [
    { value: "all", label: "Tous" },
    ...types.map((t) => ({ value: t, label: TYPE_LABELS[t] || t })),
  ];
  const compteurs = { all: total, ...Object.fromEntries(types.map((t) => [t, counts[t] ?? 0])) };

  return (
    <SegmentedFilter
      value={value}
      onChange={onChange}
      options={options}
      counts={compteurs}
      ariaLabel="Typologie de litige"
      testId="type"
    />
  );
}
